import { I18N } from "oc-I18N";
import { ConfigurationCodeInput } from "./ConfigurationCodeInput";
import { UserMenu } from "./UserMenu";
import { LegalLinks } from "./LegalLinks";

export function Header() {
  return (
    <div className="header page-initial-hidden">
      <a
        id="logo-link"
        className="logo"
        href={APP.settings.tenant?.ConfiguratorUrl}
        aria-label={I18N("aria::Neu starten")}
      >
        <img
          src={APP.settings.content_url + "/Tenant/" + APP.settings.tenant?.Logo}
          alt={I18N("aria::Firmenlogo")}
        />
        <h1 className="logo-text">{APP.settings.tenant?.LogoTitle}</h1>
      </a>

      <nav
        className="breadcrumbs togglebutton togglebutton-primary"
        data-group-key="breadcrumbs"
        aria-label={I18N("aria::Seitennavigation")}
      >
        <button
          key="neu starten"
          data-testid="Neu-starten-breadcrumb-button"
          data-button-key={I18N("Neu starten")}
          className={`togglebutton__option togglebutton__option--warning togglebutton__option--selectable`}
          aria-label={I18N("aria::Konfiguration neu starten")}
          onClick={async () => {
            APP.setStageFromConfiguration(null, APP.pageSequence[0]);
            APP.deleteAutosavedConfiguration();
            APP.arrangement.grundriss.setStandardForm("Leer");
            APP.logUserAction({ action: "restart" });
          }}
        >
          {I18N("Neu starten")}
        </button>

        {APP.pageSequence.map((pageName, index) => {
          return [
            <button
              key={pageName}
              data-testid={pageName + "-breadcrumb-button"}
              data-button-key={pageName}
              disabled={!(APP.isPageJumpable(pageName) || APP.isCurrentPage(pageName))}
              aria-current={APP.isCurrentPage(pageName) ? "page" : undefined}
              aria-label={I18N(pageName.toString())}
              className={
                APP.isCurrentPage(pageName)
                  ? "togglebutton__option togglebutton__option--active"
                  : APP.isPageJumpable(pageName)
                    ? "togglebutton__option togglebutton__option--selectable"
                    : "togglebutton__option togglebutton__option--hidden"
              }
              onClick={() => {
                if (APP.isPageJumpable(pageName)) {
                  APP.logUserAction(
                    { action: "breadCrumbClick", pageName },
                    { stateChange: false }
                  );
                  APP.showPage(pageName, { historyHandling: "push" });
                }
              }}
            >
              {I18N(pageName)}
            </button>,
          ];
        })}
      </nav>

      <aside className="header__right-menue" data-group-key="Header-rechts">
        <LegalLinks />
        <ConfigurationCodeInput />
        {APP.settings.ZeigeUserMenu && <UserMenu additionalClasses="desktopOnly" align="right" />}
      </aside>
    </div>
  );
}
